import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'
import { consume } from '@lit/context'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { productTileProductContext } from 'components/discovery/product/tile-parts/tile-product-context.js'
import { InternalProduct } from 'components/discovery/product/tile-parts/tile-parts-typing.js'


@customElement('csc-product-rating')
export class CSCProductRating extends LitElement {
  static override styles: CSSResultGroup = [hostStyle]

  @property({ type: Number })
  value: number = 0

  @property({ type: Number })
  count: number = 0

  @consume({ context: productTileProductContext })
  @state()
  private _tileProduct: InternalProduct | undefined = undefined

  override render() {
    const effectiveValue = this._tileProduct?.rating.value ?? this.value
    const effectiveCount = this._tileProduct?.rating.count ?? this.count

    return html`
      <cse-group alignment="center" column-gap="05">
        <cse-rating value="${effectiveValue}" size="sm"></cse-rating>
        <cse-text variant="body-s" class="rating-count">(${effectiveCount})</cse-text>
      </cse-group>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-product-rating': CSCProductRating
  }
}
